import { Check, Divider } from '@beamery/lib-ds-icons';
import React from 'react';
import { LabelText, IconContainer } from './checkbox.styles.js';
const Icon = (props) => {
    if (props.isSelected && props.showSelectionAsPartial) {
        return React.createElement(Divider, { size: 'small', color: 'primaryOnDark' });
    }
    if (props.isSelected) {
        return React.createElement(Check, { size: 'small', color: 'primaryOnDark' });
    }
    return null;
};
export const CheckboxDefault = (props) => (React.createElement(React.Fragment, null,
    React.createElement(IconContainer, { isHovered: props.isHovered, isSelected: props.isSelected, isFocusVisible: props.isFocusVisible },
        React.createElement(Icon, { isSelected: props.isSelected, showSelectionAsPartial: props.showSelectionAsPartial })),
    React.createElement(LabelText, { loading: props.isLoading }, props.label)));
//# sourceMappingURL=checkbox-default.component.js.map